import { Tabs } from '@tonic/shared/components/ui'
import { TabsList } from '@tonic/shared/components/ui'
import { TabsTrigger } from '@tonic/shared/components/ui'
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { cn } from '../../../utils/cn';

export function RepairLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { value: 'list', label: 'List', path: '/admin/re-commerce/repairs/list' },
    { value: 'technicians', label: 'Technicians', path: '/admin/re-commerce/repairs/technicians' },
    { value: 'program', label: 'Program', path: '/admin/re-commerce/repairs/program' },
    { value: 'analytics', label: 'Analytics', path: '/admin/re-commerce/repairs/analytics' },
    { value: 'settings', label: 'Settings', path: '/admin/re-commerce/repairs/settings' }
  ];

  const currentTab = tabs.find(tab => 
    location.pathname === tab.path || 
    (tab.value === 'list' && location.pathname === '/admin/re-commerce/repairs')
  )?.value || 'list';

  return (
    <div className="h-full flex flex-col">
      <div className="border-b border-neutral-200 bg-white">
        <div className="px-6 py-4">
          <h1 className="text-2xl font-semibold text-neutral-900">Repair Items</h1>
          <p className="text-sm text-neutral-500">Manage repair requests and technician assignments</p>
        </div>
        <div className="px-6">
          <Tabs value={currentTab} onValueChange={(value) => {
            const tab = tabs.find(t => t.value === value);
            if (tab) navigate(tab.path);
          }}>
            <TabsList className="border-b-0">
              {tabs.map((tab) => (
                <TabsTrigger
                  key={tab.value}
                  value={tab.value}
                  className={cn(
                    'flex items-center gap-2 px-4 py-2',
                    'transition-colors duration-200'
                  )}
                >
                  {tab.label}
                </TabsTrigger>
              ))}
            </TabsList>
          </Tabs>
        </div>
      </div>
      <div className="flex-1 overflow-auto bg-neutral-50">
        <Outlet />
      </div>
    </div>
  );
}
